import React from "react";
import clsx from "clsx";

import {withStyles} from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";

import {
  getQuestionAnswers,
  getQuestionSize,
  getUID,
  isQuestionValid,
  isRequiredQuestion,
  renderQuestion as renderQuestionFunc,
} from "../../../../../utils";
import styles from "./styles";

function isGroupQuestionRequired(question) {
  return question.question.some(isRequiredQuestion);
}

function isGroupQuestionValid(question, step, afterChange, service) {
  let isValid = true
  question.question.forEach(q => {
    if (!isQuestionValid(q, step, afterChange, service)) {
      isValid = false
    }
  })
  return isValid
}

function getGroupQuestionAnswer(question, withOption) {
  return question.question.map(q => getQuestionAnswers(q, withOption))
}

export const GroupQuestionMethods = {
  required: isGroupQuestionRequired,
  valid: isGroupQuestionValid,
  answer: getGroupQuestionAnswer
}

const GroupQuestion = props => {
  const {
    classes,
    question,
    onAnswerChange,
    dataService,
  } = props;

  const groupQuestionName = question.question_text || '';
  const groupQuestionTitle = question.title;
  const groupQuestionInfoText = question.info_text || '';
  let childQuestions = question.question || [], extraChildQuestions = null;
  const customClasses = question.custom_classes || {};

  if (question.uid === 'A-general') {
    childQuestions = [];
    extraChildQuestions = [];
    (question.question || []).forEach(q => {
      if(['A2','A4', 'A201', 'A401', 'A202','A402',].includes(getUID(q.uid))) {
        childQuestions.push(q)
      } else{
        extraChildQuestions.push(q)
      }
    })
  }

  const renderQuestion = (question) => {
    return renderQuestionFunc(question,onAnswerChange, dataService)
  };

  return (
    <div className={classes.groupQuestionContainer}>
      {groupQuestionTitle && (
        <div className={clsx(classes.groupQuestionTitle, customClasses.title)}>{groupQuestionTitle}</div>
      )}
      {groupQuestionName && <div className={classes.groupQuestionName}>{groupQuestionName}</div>}
      {question.description && (
        <div className={clsx(classes.groupDescription, customClasses.description)}>{question.description}</div>
      )}
      <Grid container className={clsx(classes.questionsContent, question.className)} spacing={2}>
        {childQuestions.map(renderQuestion)}
        {groupQuestionInfoText && (
          <Grid item sm={getQuestionSize()} style={{marginLeft: 'auto', fontFamily: 'Roboto-Bold', fontSize: 14}}>
            <span className='far fa-info-circle' />
            &nbsp;
            {groupQuestionInfoText}
          </Grid>
          )}
        {extraChildQuestions && extraChildQuestions.map(renderQuestion)}
      </Grid>
    </div>
  );
};

export default withStyles(styles)(GroupQuestion);
